import {http} from "../core/services/http";
import {ICreateResource, IResource} from "../core/interfaces";
import {UUID} from "node:crypto";

export const getAllResources = () =>
    http.get<IResource[]>('/api/dashboard/resources')

export const createResource = (data: ICreateResource) =>
    http.post<IResource>('/api/dashboard/resources', data)

export const updateResource = (id: string, data: ICreateResource) =>
    http.put<IResource>(`/api/dashboard/resources/${id}`, data)

export const deleteResource = (id: string) =>
    http.delete(`/api/dashboard/resources/${id}`)

export const uploadResourceFile = async (file: File): Promise<{ key: string }> => {
    const formData = new FormData()
    formData.append('file', file)
    const response = await http.post<{ key: string }>('/api/dashboard/resources/upload', formData)
    return response.data
}
